import { reportUrls } from 'constants/apiEndPoints';
import ApiUtil from '../utils/ApiUtil';

const getBankFileReport = async (page: number, size: number, date: string, filterBy: string): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`${String(reportUrls.getAllBankFileRecordReport)}?sortOrder=DESC&page=${page}&size=${size}&filter=${filterBy}&date=${date}`)
            .then((report) => {
                resolve(report);
            })
            .catch((error) => {
                reject(error);
            });
    })

const exportBankFileReport = async (date: string, filterBy: string): Promise<unknown> =>
    await new Promise((resolve, reject) => {
        ApiUtil.getExcelFile(`${reportUrls.exportBankFileRecordReport}?date=${date}&filter=${filterBy}`)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
                const blob = new Blob([res.data], { type: res.headers['content-type'] });
                const url = URL.createObjectURL(blob);
                resolve(url);
            })
            .catch((error) => {
                reject(error);
            });
    });


const exportPepReport = async (startDate: string, endDate: string): Promise<unknown> =>
    await new Promise((resolve, reject) => {
        ApiUtil.getExcelFile(`${reportUrls.exportPepReport}?startDate=${startDate}&endDate=${endDate}`)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
                const blob = new Blob([res.data], { type: res.headers['content-type'] });
                const url = URL.createObjectURL(blob);
                resolve(url);
            })
            .catch((error) => {
                reject(error);
            });
    });

const exportFeeReport = async (month: number, year: number): Promise<unknown> =>
    await new Promise((resolve, reject) => {
        ApiUtil.getExcelFile(`${reportUrls.exportFeeReport}?month=${month}&year=${year}`)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
                const blob = new Blob([res.data], { type: res.headers['content-type'] });
                const url = URL.createObjectURL(blob);
                resolve(url);
            })
            .catch((error) => {
                reject(error);
            });
    });

export {
    getBankFileReport,
    exportBankFileReport,
    exportPepReport,
    exportFeeReport
}